import { createFileRoute } from '@tanstack/react-router';

import { ContainerLibraryView } from '../../../features/containers/container-library-view';
import {
  containerListQueryOptions,
  productTypeContainerQueryOptions,
} from '../../../features/containers/queries';

export const Route = createFileRoute('/admin/containers/')({
  loader: async ({ context: { queryClient } }) => {
    await Promise.all([
      queryClient.ensureQueryData(containerListQueryOptions()),
      queryClient.ensureQueryData(productTypeContainerQueryOptions()),
    ]);
  },
  component: ContainerLibraryView,
});
